module.exports = __webpack_public_path__ + "static/media/check-mark-image.98e29cbe.png";